import React from 'react';
import { ReactComponent as CloseIcon } from '../Icons/shared/ic-shared-close.svg';

export enum CloseButtonColor {
  Black,
  White,
  Gray,
}

export enum CloseButtonSize {
  Small,
  Medium,
  Large,
}

export interface IProps {
  onClick?: () => void;
  id: string;
  color?: CloseButtonColor;
  size?: CloseButtonSize;
  className?: string;
  circle?: boolean;
}

export const CloseButton = ({ onClick, id, color, size, className, circle }: IProps) => {
  const getColorValue = () => {
    switch (color) {
      case CloseButtonColor.Gray: {
        return 'bw07';
      }
      case CloseButtonColor.Black: {
        return 'bw08';
      }
      case CloseButtonColor.White: {
        return 'bw00';
      }
      default: {
        return 'bw07';
      }
    }
  };

  const getSizeValue = () => {
    switch (size) {
      case CloseButtonSize.Small: {
        return 'h-[16px] w-[16px]';
      }
      case CloseButtonSize.Medium: {
        return 'h-[20px] w-[20px]';
      }
      case CloseButtonSize.Large: {
        return 'h-[24px] w-[24px]';
      }
      default: {
        return 'h-[20px] w-[20px]';
      }
    }
  };
  return (
    <div
      className={`${className} flex flex-row ${color !== CloseButtonColor.White && 'hover:bg-bw02'} rounded-full p-[2px] w-fit h-fit ${circle && 'rounded-full bg-bw00 shadow-sm'}`}
    >
      <button className='hover:cursor-pointer' id={id} onClick={onClick} type='button'>
        <CloseIcon className={`text-${getColorValue()} ${getSizeValue()}`} />
      </button>
    </div>
  );
};
